import React from 'react';

interface LeftArrowProps {
  className?: string;
  color?: string;
  size?: number;
}

const LeftArrow: React.FC<LeftArrowProps> = ({ className = '', color = 'white', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M9.56994 18.8201C9.37994 18.8201 9.18994 18.7501 9.03994 18.6001L2.96994 12.5301C2.67994 12.2401 2.67994 11.7601 2.96994 11.4701L9.03994 5.40012C9.32994 5.11012 9.80994 5.11012 10.0999 5.40012C10.3899 5.69012 10.3899 6.17012 10.0999 6.46012L4.55994 12.0001L10.0999 17.5401C10.3899 17.8301 10.3899 18.3101 10.0999 18.6001C9.95994 18.7501 9.75994 18.8201 9.56994 18.8201Z"
        fill="currentColor"
      />
      <path
        d="M20.4999 12.7501H3.66994C3.25994 12.7501 2.91994 12.4101 2.91994 12.0001C2.91994 11.5901 3.25994 11.2501 3.66994 11.2501H20.4999C20.9099 11.2501 21.2499 11.5901 21.2499 12.0001C21.2499 12.4101 20.9099 12.7501 20.4999 12.7501Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LeftArrow;
